import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUser, 
  faCalendar, 
  faUsers, 
  faChartBar, 
  faCog, 
  faSignOutAlt,
  faPlus,
  faEdit,
  faTrash,
  faSearch,
  faEye,
  faHome,
  faStethoscope,
  faFileAlt,
  faBell,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faClock,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faQuestionCircle,
  faHeart,
  faStar,
  faThumbsUp,
  faThumbsDown,
  faArrowLeft,
  faArrowRight,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faBars,
  faTimes as faClose,
  faDownload,
  faUpload,
  faPrint,
  faSave,
  faUndo,
  faRedo,
  faCopy,
  faPaste,
  faCut,
  faLink,
  faUnlink,
  faLock,
  faUnlock,
  faKey,
  faShieldAlt,
  faUserShield,
  faUserCheck,
  faUserTimes,
  faUserPlus,
  faUserMinus,
  faUserEdit,
  faUserCog,
  faUserGraduate,
  faUserMd,
  faUserNurse,
  faUserTie,
  faUserSecret,
  faUserNinja,
  faUserAstronaut,
  faUserFriends,
  faUserCircle,
  faUserTag,
  faUserSlash,
  faEyeSlash,
  faMinus
} from '@fortawesome/free-solid-svg-icons';
import { 
  faCalendarAlt,
  faClock as faClockRegular,
  faUser as faUserRegular,
  faEnvelope as faEnvelopeRegular,
  faFileAlt as faFileAltRegular,
  faBell as faBellRegular,
  faHeart as faHeartRegular,
  faStar as faStarRegular,
  faThumbsUp as faThumbsUpRegular,
  faThumbsDown as faThumbsDownRegular,
  faEye as faEyeRegular,
  faSave as faSaveRegular,
  faEdit as faEditRegular,
  faUserCircle as faUserCircleRegular
} from '@fortawesome/free-regular-svg-icons';

// Add all the icons to the library
library.add(
  // Solid icons
  faUser, faCalendar, faUsers, faChartBar, faCog, faSignOutAlt,
  faPlus, faEdit, faTrash, faSearch, faEye, faHome, faStethoscope,
  faFileAlt, faBell, faEnvelope, faPhone, faMapMarkerAlt, faClock,
  faCheck, faTimes, faExclamationTriangle, faInfoCircle, faQuestionCircle,
  faHeart, faStar, faThumbsUp, faThumbsDown, faArrowLeft, faArrowRight,
  faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faBars,
  faClose, faDownload, faUpload, faPrint, faSave, faUndo, faRedo,
  faCopy, faPaste, faCut, faLink, faUnlink, faLock, faUnlock, faKey,
  faShieldAlt, faUserShield, faUserCheck, faUserTimes, faUserPlus,
  faUserMinus, faUserEdit, faUserCog, faUserGraduate, faUserMd,
  faUserNurse, faUserTie, faUserSecret, faUserNinja, faUserAstronaut,
  faUserFriends, faUserCircle, faUserTag, faUserSlash, faEyeSlash, faMinus,
  
  // Regular icons
  faCalendarAlt, faClockRegular, faUserRegular, faEnvelopeRegular,
  faFileAltRegular, faBellRegular, faHeartRegular, faStarRegular,
  faThumbsUpRegular, faThumbsDownRegular, faEyeRegular,
  faSaveRegular, faEditRegular, faUserCircleRegular
);
